import React, { useEffect, useState } from 'react'
import DetailContainer from '../MainPage/common/DetailContainer'
import { images } from '../common/images';
import { config } from '../../config';
import { mqttConnectionStatus } from '../common/ApiCall';

function OnlineStatusDetailContainer({ time, selectedDeviceSelectedDayData }) {
  const [online,setOnline] = useState({})
  useEffect(()=>{
    if(Object.keys(selectedDeviceSelectedDayData).length>0 && selectedDeviceSelectedDayData?.type===config.deviceType.doorSensors){
      mqttConnectionStatus(selectedDeviceSelectedDayData.deviceId).then(res=>{
          setOnline(res)
      })
    }
  },[selectedDeviceSelectedDayData])
  let status=selectedDeviceSelectedDayData[0]?.connected?'Online':'Offline'
  if(selectedDeviceSelectedDayData[0]?.deviceId?.startsWith("KP")){
    status="Online"
  }
  return (
    <DetailContainer
      name={"Device Status"}
      value={selectedDeviceSelectedDayData?.type===config.deviceType.doorSensors?(Object.keys(online).length>0?(online?.connected?"Online":"Offline"):"Offline"):status}
      time={selectedDeviceSelectedDayData?.type===config.deviceType.doorSensors?( new Date()):time}
      color={"rgba(118, 190, 194, 0.10)"}
      borderColor={"#76BEC2"}
      image={images.deviceStatus}
    />
  )
}

export default OnlineStatusDetailContainer